export const processStatuses = [
  { id: "registered", name: "Cadastrado" },
  { id: "awaiting_review", name: "Aguardando análise" },
  { id: "under_review", name: "Em análise" },
  { id: "awaiting_documents", name: "Aguardando documentação" },
  { id: "awaiting_action", name: "Aguardando providência" },
  { id: "awaiting_response", name: "Aguardando resposta" },
  { id: "answered", name: "Respondido" },
  { id: "closed", name: "Encerrado" },
];

export const natures = [{ id: "judicial", name: "Judicial" }, { id: "administrative", name: "Administrativa" }];
export const knowledgeTypes = [
  ["official_letter", "Ofício"], ["summons", "Intimação"], ["court_email", "E-mail do juízo ou secretaria"],
  ["debtor", "Comunicação da recuperanda"], ["creditor", "Comunicação do credor"],
  ["direct_search", "Consulta direta"], ["chc", "Certidão de Habilitação de Crédito"], ["other", "Outra"],
].map(([id, name]) => ({ id, name }));

export const creditOriginTypes = [
  ["air_ticket", "Passagem aérea"], ["promo_package", "Pacote Promo"], ["hotel_booking", "Reserva de hotel"],
  ["miles", "Milhas"], ["material_damages", "Danos materiais"], ["moral_damages", "Danos morais"],
  ["fees", "Honorários"], ["labor", "Crédito trabalhista"], ["tax", "Crédito tributário"],
  ["contract", "Contrato"], ["other", "Outro"],
].map(([id, name]) => ({ id, name }));

export const communicationStatuses = [
  ["received", "Recebido"], ["under_review", "Em análise"], ["awaiting_action", "Aguardando providência"],
  ["awaiting_response", "Aguardando resposta"], ["answered", "Respondido"], ["closed", "Encerrado"],
].map(([id, name]) => ({ id, name }));

export const taskStatuses = [["pending", "Pendente"], ["in_progress", "Em andamento"], ["awaiting_information", "Aguardando informação"], ["completed", "Concluída"], ["cancelled", "Cancelada"]].map(([id, name]) => ({ id, name }));
export const priorities = [["low", "Baixa"], ["medium", "Média"], ["high", "Alta"], ["urgent", "Urgente"]].map(([id, name]) => ({ id, name }));
export const currencies = [{ id: 1, name: "BRL (R$)" }, { id: 2, name: "USD ($)" }, { id: 3, name: "EUR (€)" }];
export const impactTypes = [
  ["enable_credit", "Habilitar crédito (CHC)"],
  ["credit_addition", "Adicionar crédito ao QGC"],
  ["credit_reduction", "Reduzir crédito"],
  ["credit_replacement", "Substituir crédito"],
  ["class_change", "Alterar classe"],
  ["payment_partial", "Registrar pagamento parcial"],
  ["payment_full", "Registrar pagamento integral"],
  ["subrogation", "Registrar sub-rogação"],
  ["credit_exclusion", "Excluir crédito por decisão"],
].map(([id, name]) => ({ id, name }));

export const legacyImpactTypes = [
  ["change_amount", "Alterar valor (legado)"],
  ["change_class", "Alterar classe (legado)"],
  ["register_payment", "Registrar pagamento (legado)"],
  ["exclude_credit", "Excluir crédito (legado)"],
].map(([id, name]) => ({ id, name, legacy: true }));

export const labelOf = (items, id) => (items.find(item => String(item.id) === String(id)) || {}).name || id || "—";

export const statusTone = status => ({ closed: "neutral", answered: "success", under_review: "primary", awaiting_response: "purple", awaiting_action: "warning", awaiting_documents: "warning", registered: "neutral", awaiting_review: "neutral", completed: "success", cancelled: "neutral", applied: "success", rejected: "danger", failed: "danger", sent: "primary", validating: "purple" }[status] || "neutral");
